import Header from "../../structures/header/index";
import Footer from "../../structures/footer/index";
import "../../../assets/css/portfolio.css";

/* ── Project images (served from /public/img/project/) ── */
const IMG_WEBSITE  = process.env.PUBLIC_URL + "/img/project/alaisebythelake.webp";
const IMG_BOOKING  = process.env.PUBLIC_URL + "/img/project/alaisebooking.webp";
const IMG_PRESENSI = process.env.PUBLIC_URL + "/img/project/presensi.webp";
const IMG_FARM      = process.env.PUBLIC_URL + "/img/project/farm.webp";
const IMG_INVENTORY = process.env.PUBLIC_URL + "/img/project/inventory.webp";
const IMG_RAGDOC    = process.env.PUBLIC_URL + "/img/project/obscur.webp";

const projects = [
  {
    id: 1,
    img: IMG_WEBSITE,
    alt: "Sleek dark website interface mockup with modern typography and minimal layout",
    title: "Website Development",
    tag: "WEB",
    stack: ["React", "Node.js", "CSS"],
    desc: "Perancangan dan pengembangan website profesional yang modern, responsif, dan berperforma tinggi — mulai dari landing page hingga company profile yang memukau.",
  },
  {
    id: 2,
    img: IMG_BOOKING,
    alt: "Dark booking system dashboard with calendar UI, time slots, and reservation cards",
    title: "Sistem Booking",
    tag: "BOOKING",
    stack: ["React", "Node.js", "MySQL"],
    desc: "Solusi pemesanan digital yang terintegrasi untuk restoran, cafe, dan layanan bisnis — kelola jadwal, reservasi, dan notifikasi secara real-time.",
  },
  {
    id: 3,
    img: IMG_PRESENSI,
    alt: "Dark attendance tracking dashboard with biometric check-in and employee presence grid",
    title: "Sistem Presensi",
    tag: "HR TECH",
    stack: ["React", "Express", "Laravel"],
    desc: "Sistem absensi digital berbasis web untuk perusahaan dan UMKM — rekap otomatis, laporan harian, dan manajemen karyawan dalam satu platform.",
  },
  {
    id: 4,
    img: IMG_FARM,
    alt: "Farm management system dashboard with crop tracking and field monitoring",
    title: "Farm Management System",
    tag: "AGRITECH",
    stack: ["React", "Node.js", "PostgreSQL"],
    desc: "Platform manajemen pertanian digital — pantau lahan, kelola panen, dan lacak produktivitas secara real-time dalam satu sistem terpadu.",
  },
  {
    id: 5,
    img: IMG_INVENTORY,
    alt: "Inventory management dashboard with stock tracking and warehouse overview",
    title: "Inventory System",
    tag: "INVENTORY",
    stack: ["React", "Express", "MySQL"],
    desc: "Sistem manajemen stok dan gudang yang efisien — kelola barang masuk, barang keluar, dan laporan inventaris secara otomatis dan akurat.",
  },
  {
    id: 6,
    img: IMG_RAGDOC,
    alt: "AI document assistant interface with chat and document retrieval",
    title: "AI RAG Document",
    tag: "AI",
    stack: ["Python", "LangChain", "FastAPI"],
    desc: "Asisten dokumen berbasis AI dengan teknologi Retrieval-Augmented Generation — tanya, cari, dan ekstrak informasi dari dokumen secara instan dan cerdas.",
  },
];

export default function PortfolioPage() {
  return (
    <>
      <Header activePage="portfolio" />

      <main className="pf-main">

        {/* ══════════════════════════════
            HERO
        ══════════════════════════════ */}
        <section className="pf-hero">
          <div className="pf-container">
            <div className="pf-hero__grid">

              <div className="pf-hero__left">
                <h1 className="pf-hero__title">
                  SELECTED<br />WORK
                </h1>
                <p className="pf-hero__desc">
                  Engineering digital monoliths. We sculpt high-fidelity experiences
                  for the next era of enterprise cloud and intelligence systems.
                </p>
              </div>

              <div className="pf-hero__right">
                <span className="pf-hero__archive-label">ARCHIVE NO. 24-001</span>
                <div className="pf-hero__archive-line" aria-hidden="true" />
              </div>

            </div>
          </div>
        </section>

        {/* ══════════════════════════════
            PROJECT GRID
        ══════════════════════════════ */}
        <section className="pf-works">
          <div className="pf-container">
            <div className="pf-grid">

              {projects.map((project) => (
                <div key={project.id} className="pf-card">
                  <div className="pf-card__img-wrap">
                    <img
                      src={project.img}
                      alt={project.alt}
                      className="pf-card__img"
                    />
                    <div className="pf-card__img-overlay" />
                  </div>

                  <div className="pf-card__body">
                    <div className="pf-card__head">
                      <h3 className="pf-card__title">{project.title}</h3>
                      <span className="pf-card__tag">{project.tag}</span>
                    </div>

                    <div className="pf-card__stack">
                      {project.stack.map((tech) => (
                        <span key={tech} className="pf-chip">{tech}</span>
                      ))}
                    </div>

                    <p className="pf-card__desc">{project.desc}</p>

                    <button className="pf-card__cta">
                      View Case Study
                      <span className="material-symbols-outlined pf-card__cta-icon">
                        arrow_forward
                      </span>
                    </button>
                  </div>
                </div>
              ))}

            </div>

            {/* ── CTA Banner ── */}
            <div className="pf-cta">
              <div className="pf-cta__text">
                <h2 className="pf-cta__title">INSPIRED BY OUR WORK?</h2>
                <p className="pf-cta__sub">
                  Jelajahi studi kasus kami, atau hubungi kami untuk mendiskusikan proyek digital Anda berikutnya.
                </p>
              </div>
                        <a
                          className="pf-cta__btn"
                          href="https://wa.me/62895635363191?text=Hallo%20Codelune%2C%20saya%20mau%20tanya-tanya%20dulu%20tentang%20project%20digital.%20Terima%20kasih!"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Mulai Konsultasi
                        </a>
            </div>

          </div>
        </section>

      </main>

      <Footer />
    </>
  );
}
